import { IPermissao } from "@/interfaces/IPermissao";
import { api } from "@/services/api";
import { useAuth } from "react-oidc-context";
import { useUsuarioLogado } from "./useUsuarioLogado";

export const usePermissao = () => {
  const { user } = useAuth();
  const { usuarioLogado } = useUsuarioLogado();

  const getPermissoes = async () => {
    const { data } = await api.get<IPermissao[]>(`/permissoes/todas`, {
      headers: {
        Authorization: `Bearer ${user?.access_token}`,
      },
    });
    return data;
  };

  const hasEnabledPermissao = (nomePermissao: string) => {
    if (!usuarioLogado.perfil) return false;

    const permissaoEncontrada = usuarioLogado.perfil.permissoes.find(
      (permissao) => permissao.nome === nomePermissao
    );

    return Boolean(permissaoEncontrada);
  };

  const hasEnabledRoute = (route: string) => {
    if (route.includes("requisicoes/novo")) {
      return hasEnabledPermissao("RAL_CRIAR");
    }

    if (route.includes("requisicoes/visualizar")) {
      return hasEnabledPermissao("RAL_VISUALIZAR");
    }

    if (route.includes("certificados/novo")) {
      return hasEnabledPermissao("CERTIFICADO_CRIAR");
    }

    if (route.includes("termos-notificacao/novo")) {
      return hasEnabledPermissao("TERMO_NOTIFICACAO_CRIAR");
    }

    if (route.includes("termos-notificacao/visualizar")) {
      return hasEnabledPermissao("TERMO_NOTIFICACAO_VISUALIZAR");
    }

    if (route.includes("relatorioAM/novo")) {
      return hasEnabledPermissao("RAM_AUDITORIA_CRIAR");
    }

    if (route.includes("perfis") && usuarioLogado.perfil.id !== 1) {
      return false;
    }

    return true;
  };

  return { getPermissoes, hasEnabledPermissao, hasEnabledRoute };
};
